import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { EddyAutoComplete, GlobalService, Login, Recurso, Produto, UnidadeRecurso, UsuarioService, Usuario, FuncaoService } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RecursoService } from 'administrativo-lib';
import { UnidadeRecursoService } from '../service/unidade-recurso.service';
import { ConfirmationService } from 'primeng/api';
import * as toastr from 'toastr';

declare var $: any;

@Component({
  selector: 'lib-unidade-recurso',
  templateUrl: './unidade-recurso.component.html'
})
export class UnidadeRecursoComponent implements OnInit, OnChanges, OnDestroy {

  public itemAtual: UnidadeRecurso;
  public itemRecurso: UnidadeRecurso;
  public recursoAutoComplete: EddyAutoComplete<Recurso>;
  public usuarioAutoComplete: EddyAutoComplete<Usuario>;
  protected unsubscribe: Subject<void> = new Subject();

  @Input() lista: Array<any>;
  @Input() entidade: Produto;
  @Input() login: Login;

  @ViewChild('btnAdicionar') public btnAdicionar: ElementRef;

  constructor(
    protected recursoService: RecursoService,
    protected usuarioService: UsuarioService,
    protected unidadeRecursoService: UnidadeRecursoService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService,
    protected confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {
    this.carregarAutoCompletes();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.lista) {
    //   this.listaRecursos = this.lista;
    // }
  }

  public adicionar() {
    this.itemAtual = new UnidadeRecurso();
    this.itemAtual.editavel = true;
    if (!this.lista) {
      this.lista = [];
    }
    this.lista.unshift(this.itemAtual);
    this.btnAdicionar.nativeElement.disabled = true;
  }

  public replicarResponsavelParaTodos(item: UnidadeRecurso) {
    try {
      if (!item.aplicacao_variavel || !item.aplicacao_variavel.id) {
        throw new Error('Informe a Recurso!');
      }
      if (!item.usuario || !item.usuario.id) {
        throw new Error('Informe o Responsável!');
      }
      if (this.lista.length > 1) {
        this.confirmationService.confirm({
          message: `Executar o mesmo responsável para todos os recursos?`,
          header: `Atenção`,
          icon: 'pi pi-exclamation-triangle',
          key: 'todosResponsaveis',
          acceptLabel: 'Sim',
          rejectLabel: 'Não',
          accept: async () => {
            this.lista.forEach((itemLista) => {
              itemLista.usuario = item.usuario
              itemLista.cargo = item.cargo;
            });
            this.salvar(item);
          },
          reject: async () => {
            this.salvar(item);
          }
        });
      } else {
        this.salvar(item);
      }

    } catch (e) {
      this.funcaoService.acaoErro(e)
      throw e;
    }
  }

  public salvar(item: UnidadeRecurso) {
    try {
      this.btnAdicionar.nativeElement.disabled = false;
      this.itemAtual.editavel = false;
      this.lista.sort((a, b) => {
        if (a.aplicacao_variavel.codigo && b.aplicacao_variavel.codigo) {
          return a.aplicacao_variavel.codigo.localeCompare(b.aplicacao_variavel.codigo);
        }
        return 0;
      })
      this.adicionar();
    } catch (e) {
      this.funcaoService.acaoErro(e)
      throw e;
    }
  }

  public editar(item: UnidadeRecurso) {
    this.itemAtual = item;
    this.itemAtual.editavel = true;
    this.btnAdicionar.nativeElement.disabled = true;
  }

  public cancelar(item: UnidadeRecurso) {
    this.itemAtual = item;
    if (!this.itemAtual.id) {
      this.lista.splice(this.lista.findIndex((itm) => { return itm === item }), 1);
    } else {
      this.itemAtual.editavel = false;
    }
    this.btnAdicionar.nativeElement.disabled = false;
  }

  public remover(item: UnidadeRecurso) {
    if (item.id) {
      this.unidadeRecursoService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          toastr.success('Registro removido com sucesso!', 'Exclusão');
        });
    }
    this.lista.splice(this.lista.findIndex((itm) => { return itm === item }), 1);
    this.btnAdicionar.nativeElement.disabled = false;
  }

  private carregarAutoCompletes() {
    this.recursoAutoComplete = new EddyAutoComplete(null, this.recursoService,
      'id', ['codigo', 'nome'], { cidade_id: this.login.cidade.id, orderBy: 'codigo', ativo: true, nivel: 2 }, { number: ['codigo'], text: ['codigo', 'nome'] }, async () => {
        if (this.lista.find((item) => item.aplicacao_variavel && item.aplicacao_variavel.id === this.itemAtual.aplicacao_variavel.id && this.itemAtual['editavel'] && !item['editavel'])) {
          this.itemAtual.aplicacao_variavel = null;
          this.recursoAutoComplete.id = null;
          toastr.error('Recurso já adicionado!', 'Erro');
          return;
        }
      }, null, (recurso) => {
        if (this.lista?.find((item) => item?.aplicacao_variavel && item?.aplicacao_variavel.id === recurso?.id && this.itemAtual['editavel'] && !item['editavel'])) {
          return '';
        } else {
          return recurso.codigo + ' - ' + recurso.nome
        }
      }
    );

    this.usuarioAutoComplete = new EddyAutoComplete(null, this.usuarioService,
      'id', ['cpf', 'nome', 'sobrenome'], { orgao_id: this.login.orgao.id, orderBy: 'nome', ativo: true }, { number: ['id'], text: ['email', 'nome', 'sobrenome', 'cpf'] }
    );
  }

  incluirEditarSubstituto(item: UnidadeRecurso) {
    this.itemRecurso = item;
    $('#unidadeRecursoSubstituto').modal('show');
  }

}
